import Component from '../abstracts/Component';

export default class ResultFiltersLabelComponent extends Component {

    get SELECTORS() {
        return {
            main: '#filters-box',
            labels: '[data-filter-id]',
            filterBtnWithCounter:'[data-total-filters]',
        };
    }

    constructor() {
        super();
    }

    enableInput(id){
        let inputEl = document.getElementById(id);
        if(inputEl){
            inputEl.disabled = false;
        }else{
            return '';
        }
    }

    polyFillRemove(){
        // Create Element.remove() function if not exist
        if (!('remove' in Element.prototype)) {
            Element.prototype.remove = function() {
                if (this.parentNode) {
                    this.parentNode.removeChild(this);
                }
            };
        }
    }
    removeLabel(label){
        this.polyFillRemove();
        let containerLabel = label.parentElement;
        containerLabel.remove();
    }
    // removeAll(){
    //     this.polyFillRemove();
    //     let removeTrigger = document.getElementById(this.SELECTORS.removeAll);
    //     let parentTrigger = removeTrigger.parentElement;
    //     let inputsFromlabels = document.querySelectorAll(this.SELECTORS.labels);
    //     removeTrigger.addEventListener('click',()=>{
    //         for(let label of inputsFromlabels){
    //             let inputId = label.dataset.filterId;
    //             this.enableInput(inputId);
    //             this.removeLabel(label);
    //         }
    //         parentTrigger.remove();
    //     })
    // }
    labelsHandler(){
        let labels = document.querySelectorAll(this.SELECTORS.labels);
        let ctx = this;
        for(let label of labels){
          $(label).on("click", function () {
            let inputId = label.dataset.filterId;
            ctx.enableInput(inputId);
            ctx.removeLabel(label);
          })
        }
        //this.removeAll();
    }
    mobileFilterCounter(){
        let btnWithCounter = document.querySelector(this.SELECTORS.filterBtnWithCounter);
        let isMobile = window.matchMedia('(max-width:767px)').matches;

        let filtersInputs = document.querySelectorAll(this.SELECTORS.labels);

        if(isMobile){
            btnWithCounter.dataset.totalFilters = filtersInputs.length;
        }
    }
    render() {
        if (document.querySelectorAll(this.SELECTORS.main)) {
            this.labelsHandler();
            this.mobileFilterCounter();
        }
        let myName = this.constructor.name
        console.log(`[${myName}] Rendering..`);
    }
}
